import {postAndDeserialize} from '../../util/api-adapter';

import {
    PhoneCommentVisibilityPayloadType,
    phoneCommentVisibilitySchema,
    PhoneCommentVisibilityType,
} from './phone-comment-visibility-type';

export const phoneCommentVisibilityUrl = '/cp/phone_comment_visibility/';

export async function fetchPhoneCommentVisibility(
    payload: PhoneCommentVisibilityPayloadType
): Promise<PhoneCommentVisibilityType> {
    return postAndDeserialize<PhoneCommentVisibilityType>(
        phoneCommentVisibilityUrl,
        phoneCommentVisibilitySchema,
        payload
    );
}
